import { AccessLevel, Section as SectionType } from 'app/frontend/types/custom'
import { accessLevels } from 'app/frontend/types/custom/AccessLevel'

export const getAccessLevelForTeam = (
  guild: wowaudit.Guild | undefined,
  section: SectionType,
  teamId: number | string | undefined,
) => {
  return teamId
    ? guild?.teamAccessLevels[teamId.toString()]?.[section] ?? 'none'
    : 'none'
}

export const hasAccessToContent = (
  requirement: AccessLevel,
  section: SectionType,
  guild?: wowaudit.Guild,
  teamReference?: wowaudit.TeamReference,
  requireAllTeams = false,
) => {
  const teamAccessIds = Object.keys(guild?.teamAccessLevels ?? {})
  const access = requireAllTeams
    ? teamAccessIds.length > 0
      ? teamAccessIds.map((id) => getAccessLevelForTeam(guild, section, id))
      : ['none' as const]
    : [getAccessLevelForTeam(guild, section, teamReference?.id)]

  const accessLevel =
    section === 'none'
      ? 'admin'
      : access.reduce(
          (highest, current) =>
            accessLevels.indexOf(current) > accessLevels.indexOf(highest)
              ? current
              : highest,
          'admin',
        )

  const hasAccess =
    accessLevels.indexOf(accessLevel) <= accessLevels.indexOf(requirement)

  return { accessLevel, hasAccess }
}

export const hasAdminAccessToAllTeams = (
  guild: wowaudit.Guild | undefined,
  section: SectionType = 'base',
) => hasAccessToContent('admin', section, guild, undefined, true).hasAccess

export const hasEventPlanAdminAccess = (
  eventsAccessLevel: AccessLevel,
  guild: wowaudit.Guild | undefined,
  teamId: number | string | undefined,
) =>
  eventsAccessLevel === 'admin' ||
  getAccessLevelForTeam(guild, 'plans', teamId) === 'admin'
